import NonCriticalError from '@/errors/NonCriticalError.js';

class UploadDataTooLargeError extends NonCriticalError {
}

export default UploadDataTooLargeError;
